window.Samcart.Embed.Core.registerModule('Popup', (function () {

    /**
     *
     * @constructor
     */
    function Popup() {

    }

    /**
     * This module will be rendered when some event (usually a click) occurs
     *
     * @type {string}
     */
    Popup.prototype.render_type = 'event';

    /**
     * Elements must have the sc-popup attribute in addition to the sc-embed attribute
     *
     * @param {Element} ele
     * @returns {boolean}
     */
    Popup.prototype.elementMatchesModule = function(ele) {
        return ele.hasAttribute('sc-popup');
    };

    /**
     * -click is used for the tag to stay in sync with the tag generated by core
     *
     * @param {string} marketplaceToken
     * @param {string} productSlug
     * @returns {string}
     */
    Popup.prototype.generateTag = function(marketplaceToken, productSlug) {
        return (marketplaceToken + '-' + productSlug + '-click').toLowerCase();
    };

    /**
     *
     * @param {string} url
     * @param {string} tag
     */
    Popup.prototype.createComponent = function(tag, url) {

        return xcomponent.create({
            tag: tag,
            url: url,
            defaultLogLevel: 'error',
            containerTemplate: function (opts) {
                opts.outlet.id = opts.id;
                return opts.jsxDom("div", {id: opts.id},
                    opts.jsxDom("style", null,
                        "#" + opts.id + " { position: fixed; z-index: 2147483647; width: 100%; height: 100%; top: 0; bottom: 0; left: 0; right: 0;}" +
                        "\n #" + opts.id + " .xcomponent-outlet {height: 100%; width: 100%; position: relative; }" +
                        "\n #" + opts.id + " .xcomponent-outlet iframe { height: 100%; width: 100%;`)"),
                    opts.outlet);
            }
        });
    };

    return new Popup();
})());